<div dir="rtl" class="menu-button">
	<button mat-icon-button [matMenuTriggerFor]="menu" data-test-id="more-button" #menuTrigger='matMenuTrigger'
	        matTooltip="Weitere Funktionen"
	        tabindex="0" aria-haspopup="menu" aria-label="Weitere Funktionen" class="focus-inwards-light">
		<mat-icon inline="true">more_vert</mat-icon>
	</button>
	<mat-menu #menu="matMenu" class="menu">
		<button class="menu-item focus-inwards-dark" mat-menu-item (click)="openNotizDialog($event)"
		        data-test-id="notiz-button"
		        aria-label="Notiz bearbeiten"
		        matTooltip="Notiz bearbeiten">
			<mat-icon>notes</mat-icon>
			<span id="bt-notiz">Notiz</span>
		</button>
		@if (hasRegisterBlatt()) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openRegisterBlatt()"
			        data-test-id="registerblatt-button"
			        aria-label="Registerblatt anzeigen"
			        matTooltip="Registerblatt anzeigen">
				<mat-icon>table_chart</mat-icon>
				<span id="bt-registerblatt">Registerblatt</span>
			</button>
		}
		@if (verfahren | hasResourceLink: linkRel.REGISTERBLATT_SCHIFFSZERTIFIKAT) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="downloadSchiffszertifikat()"
			        data-test-id="schiffszertifikat-button"
			        aria-label="Schiffszertifikat erstellen und herunterladen"
			        matTooltip="Schiffszertifikat erstellen und herunterladen">
				<mat-icon class="icon-award icon-right" aria-hidden="true"/>
				<span id="bt-schiffszertifikat">Schiffszertifikat</span>
			</button>
		}
		@if (verfahren | hasResourceLink: linkRel.REGISTERBLATT_SCHIFFSBRIEF) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="downloadSchiffsbrief()"
			        data-test-id="schiffsbrief-button"
			        aria-label="Schiffsbrief erstellen und herunterladen"
			        matTooltip="Schiffsbrief erstellen und herunterladen">
				<mat-icon class="icon-award icon-right" aria-hidden="true"/>
				<span id="bt-schiffsbrief">Schiffsbrief</span>
			</button>
		}
		@if (verfahren | hasResourceLink: linkRel.REGISTERBLATT_AMTLICHER_AUSZUG) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openAmtlichenAuszugErstellenDialog()"
			        data-test-id="amtlicher-auszug-button"
			        aria-label="Amtlichen Auszug erstellen und herunterladen"
			        matTooltip="Amtlichen Auszug erstellen und herunterladen">
				<mat-icon class="icon-bundesadler icon-right" aria-hidden="true"/>
				<span id="bt-amtlicher-auszug">Amtlicher Auszug</span>
			</button>
		}
		@if (verfahren | hasResourceLink: linkRel.MARK_AS_ABGELEHNT) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="markAsAbgelehnt($event)"
			        data-test-id="ablehnen-button"
			        aria-labelledby="bt-verfahren-ablehnen"
			        matTooltip="Verfahren ablehnen">
				<mat-icon>pan_tool</mat-icon>
				<span id="bt-verfahren-ablehnen">Verfahren ablehnen</span>
			</button>
		}
		@if ((verfahren | hasResourceLink: linkRel.ASSIGN_USIGNAL) && verfahren.register === 'SSR') {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openUsignalZuordnenDialog()"
			        data-test-id="add-usignal-button"
			        aria-labelledby="bt-usignal-zuordnen"
			        matTooltip="U-Signal zuordnen">
				<mat-icon>notification_important</mat-icon>
				<span id="bt-usignal-zuordnen">U-Signal zuordnen</span>
			</button>
		}
		@if ((verfahren | hasResourceLink: linkRel.STANDORT_AKTE)) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openStandortAkteDialog()"
			        data-test-id="standort-akte-button"
			        aria-label="Standort der Akte bearbeiten"
			        matTooltip="Standort der Akte bearbeiten">
				<mat-icon>edit_location</mat-icon>
				<span id="bt-standort-akte">Standort der Akte</span>
			</button>
		}
		@if ((verfahren | hasResourceLink: linkRel.AR_KENNZEICHEN)) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openKennzeichenDialog()"
			        data-test-id="kennzeichen-button"
			        aria-label="Kennzeichen erfassen"
			        matTooltip="Kennzeichen erfassen">
				<mat-icon>fingerprint</mat-icon>
				<span id="bt-kennzeichen">Kennzeichen</span>
			</button>
		}
		@if ((verfahren | hasResourceLink: linkRel.ZAEHLBLATT)) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openZaehlblattErfassenDialog()"
			        data-test-id="zaehlblatt-erfassen-button"
			        aria-labelledby="bt-zaehlblatt_erfassen"
			        matTooltip="Zählblattaktion erfassen">
				<mat-icon>playlist_add</mat-icon>
				<span id="bt-zaehlblatt_erfassen">Zählblattaktion erfassen</span>
			</button>
		}
		@if ((verfahren | hasResourceLink: linkRel.ZAEHLBLATT)) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openZaehlblattAnzeigenDialog()"
			        data-test-id="zaehlblatt-anzeigen-button"
			        aria-labelledby="bt-zaehlblatt-anzeigen"
			        matTooltip="Zählblattaktion anzeigen">
				<mat-icon>playlist_add_check</mat-icon>
				<span id="bt-zaehlblatt-anzeigen">Zählblattaktion anzeigen</span>
			</button>
		}
		@if (verfahren | hasResourceLink: linkRel.ZUGEORDNETE_VERFAHREN) {
			<button class="menu-item focus-inwards-dark" mat-menu-item
			        (click)="openZugeordneteVerfahrenDialog()"
			        aria-label="Zugeordnete Verfahren bearbeiten"
			        matTooltip="Zugeordnete Verfahren bearbeiten">
				@if (!verfahren.zuordnungen || verfahren.zuordnungen.hauptverfahren.aktenzeichen === verfahren.stammdaten.aktenzeichen) {
					<mat-icon style="transform: rotate(180deg)">call_split</mat-icon>
				} @else {
					<mat-icon>merge_type</mat-icon>
				}
				<span id="bt-zugeordnete-verfahren">Zugeordnete Verfahren</span>
			</button>
		}
	</mat-menu>
</div>
